import { baseUrl } from 'config/config';
import { useState, useEffect } from 'react';
import { getApiCall, postApiCall, postApiCallNoToken } from './apiHelper';
import { DashboardResponse, FilterModel, Lease, LeaseFilters } from '../all_Interfaces';

export class UserRoleMapService {

    async FetchUserRoleDashboardData(payload: any) {
        try {
            var url = `${baseUrl}UserRoleMap/GetAllUserRolesView`;
            const response = await postApiCall<any, any>(url, payload);

            return response.result;
        } catch (error: any) {
            console.error('Error in GET request:', error);
        }
    }

    async FetchActiveDashboardData(payload: any) {

        try {
            var url = `${baseUrl}Leases/GetActiveLeases`;
            const response = await postApiCall<any, any>(url, payload);

            return response.result;
        } catch (error: any) {
            console.error('Error in GET request:', error);
        }
    }


}
